const Badge = (props) => {
  return (
    <span className={`badge ${props.type} ${props.badge} badge-sm me-1 mb-1 mt-1`}>
      {props.name}
    </span>
  )
}

export default Badge
